module.exports = __webpack_public_path__ + "static/team-impulse-hype-d39a768495c34adfb4a156a0440bebd4.mp4";